<template>
  <vs-popup
    fullscreen
    :title="$t('RolePermissions') + roleCurrent.name"
    :active.sync="popupActive"
    ><div v-if="loaded">
      <form>
        <div class="vx-row mb-2">
          <div class="vx-col w-full p-0">
            <tree-children-select
              ref="grid"
              stripe
              :data-source="gridDataSource"
              @apiCall="apiCall"
            ></tree-children-select>
          </div>
        </div>
      </form>
    </div>

    <div id="loadingData" v-else>
      <svg
        class="spinner"
        width="65px"
        height="65px"
        viewBox="0 0 66 66"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          class="path"
          fill="none"
          stroke-width="6"
          stroke-linecap="round"
          cx="33"
          cy="33"
          r="30"
        ></circle>
      </svg>
    </div>
  </vs-popup>
</template>
<style lang="scss">
#loadingData {
  margin: 0 auto;
  width: 100%;
  padding: 3rem 0;
}
</style>
<script>
import { mapActions } from "vuex";
import TreeChildrenSelect from "@/components/treechildren/TreeChildrenSelect";
export default {
  name: "user-management-Roles-PermissionPopup",
  props: {
    show: { default: false },
    roleCurrent: {},
  },
  components: {
    TreeChildrenSelect,
  },
  data() {
    return {
      PermissionPopup: false,
      disableOnSubmit: false,
      model: [],
      loaded: false,
      gridDataSource: {
        type: "app",
        service: "",
      },
    };
  },
  computed: {
    popupActive: {
      get: function () {
        return this.show;
      },
      set: function () {
        this.$emit("close");
      },
    },
  },
  methods: {
    ...mapActions({
      updateRolePermissions: "role/updateRolePermissions",
    }),
    apiCall(list) {
      this.model = {
        roleId: this.roleCurrent.id,
        permissionIds: list,
      };
      this.updateRolePermissions(this.model).then(() => {
        this.$swal({
          position: "center-center",
          type: "success",
          text: "رکورد مورد‌نظر با موفقیت ویرایش شد!",
          showConfirmButton: false,
          timer: 2000,
        });
        this.$emit("finish");
        this.model = [];
        this.disableOnSubmit = false;
      });
    },
  },
  watch: {
    show() {
      this.model = {
        roleId: this.roleCurrent.id,
        permissions: [],
      };
      if (this.show == true) {
        this.gridDataSource = {
          type: "app",
          service:
            "IdentityAccess/api/RolesQuery/" +
            this.roleCurrent.id +
            "/permissions",
        };
        setTimeout(() => {
          this.loaded = true;
        }, 200);
      } else {
        this.loaded = false;
      }
    },
  },
};
</script>
